import { Save } from "lucide-react";
import { L, cls, StatusSelect, unitOptions } from "./shared";
import { BasisSelect } from "../services/servicesShared";

// Proje içi hizmet ekle/düzenle formu (başlık, ad, birim, durum + geçerli lokasyonlar)
export default function SvcForm({ form, setForm, editing, catLocked, activeCats, services, locs, onSubmit, onCancel }) {
  const unitLocked = !!editing && editing !== "new" && !!services.find((x) => x.id === editing)?.price_valid_from;
  const toggleLoc = (id, on) => setForm({ ...form, location_ids: on ? form.location_ids.filter((x) => x !== id) : [...form.location_ids, id] });
  return (
    <form onSubmit={onSubmit} className="bg-white border border-slate-200 rounded-md p-4 space-y-3" data-testid="svc-form">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <L label="Hizmet Ana Başlığı">
          <select required disabled={catLocked} data-testid="svc-field-category" value={form.category_id} onChange={(e) => setForm({ ...form, category_id: e.target.value })} className={`${cls} disabled:bg-slate-100 disabled:text-slate-600 disabled:cursor-not-allowed`}>
            <option value="">Seçiniz…</option>
            {activeCats.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          {catLocked && <div className="text-[10px] text-amber-700 mt-1" data-testid="svc-cat-locked-hint">Başlık otomatik seçildi — bu hizmet seçili başlığın altında açılır, değiştirilemez.</div>}
        </L>
        <L label="Hizmet Adı"><input required data-testid="svc-field-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={cls} /></L>
        <L label="Ölçü Birimi">
          <select data-testid="svc-field-unit" value={form.unit} disabled={unitLocked} onChange={(e) => setForm({ ...form, unit: e.target.value })} className={`${cls} disabled:bg-slate-100 disabled:text-slate-600`}>
            {unitOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          {unitLocked && <div className="text-[10px] text-amber-700 mt-1" data-testid="svc-unit-locked-hint">Birim ve birim fiyatı Fiyatlar sekmesinden güncellenir.</div>}
        </L>
        <L label="Hesap Esası (Kişi Bazlı / Aylık)"><BasisSelect value={form.billing_basis} onChange={(v) => setForm({ ...form, billing_basis: v })} testid="svc-field-basis" /></L>
        <L label="Durum"><StatusSelect value={form.status} onChange={(v) => setForm({ ...form, status: v })} /></L>
        <div className="flex items-end gap-2 justify-end">
          <button type="button" onClick={onCancel} data-testid="svc-cancel" className="px-3 py-2 rounded-md border border-slate-300 bg-white text-xs font-semibold text-slate-600 hover:bg-slate-50">İptal</button>
          <button type="submit" data-testid="svc-save" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800"><Save className="w-3.5 h-3.5" /> Kaydet</button>
        </div>
      </div>
      <div className="space-y-1.5">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Geçerli Lokasyonlar (boş = tüm şubeler, yeni açılanlar dahil)</label>
          {locs.length > 0 && (
            <div className="flex items-center gap-2">
              <span className="text-[11px] text-slate-500" data-testid="svc-loc-count">{form.location_ids.length} / {locs.length} seçili</span>
              <button type="button" data-testid="svc-loc-select-all" title="Listeyi bugünkü şubelerle dondurur — sonradan açılan şubeler otomatik gelmez. Yeni şubeler de gelsin istiyorsanız listeyi boş bırakın (Temizle)."
                onClick={() => setForm({ ...form, location_ids: locs.map((l) => l.id) })}
                className="px-2.5 py-1 rounded-md text-[11px] font-semibold border border-slate-300 bg-white text-slate-700 hover:bg-slate-50">
                Tümünü Seç
              </button>
              <button type="button" data-testid="svc-loc-clear"
                onClick={() => setForm({ ...form, location_ids: [] })}
                className="px-2.5 py-1 rounded-md text-[11px] font-semibold border border-slate-300 bg-white text-slate-500 hover:bg-slate-50">
                Temizle
              </button>
            </div>
          )}
        </div>
        <div className="border border-slate-200 rounded-md max-h-64 overflow-y-auto divide-y divide-slate-100 bg-white" data-testid="svc-field-locations">
          {locs.map((l) => {
            const on = form.location_ids.includes(l.id);
            return (
              <label key={l.id} data-testid={`svc-loc-${l.id}`}
                className={`flex items-center gap-2.5 px-3 py-1.5 cursor-pointer text-xs transition-colors ${on ? "bg-amber-50" : "hover:bg-slate-50"}`}>
                <input type="checkbox" checked={on} data-testid={`svc-loc-check-${l.id}`} onChange={() => toggleLoc(l.id, on)} className="accent-slate-900 w-3.5 h-3.5" />
                <span className={on ? "font-semibold text-slate-900" : "text-slate-600"}>{l.branch_code ? l.branch_code + " " : ""}{l.district} {l.name}</span>
              </label>
            );
          })}
          {locs.length === 0 && <div className="text-xs text-slate-400 px-3 py-2.5">Önce lokasyon ekleyin</div>}
        </div>
      </div>
    </form>
  );
}
